import React from "react";
import LockIcon from "../components/LockIcon";

export default function DrawerSplashForPods() {
  return (
    <div className="drawersplash">
      <div className="container-img">
        <LockIcon />
      </div>
      <div className="container-text">
        <div className="confirmation-screen">
          <h2 style={{ textAlign: "left" }}>ACTIVATE GAME TO PLAY</h2>
          {/* <p>Refer to your email for access code and activation link.</p> */}
          <p>Check with your event organizer for activation instructions.</p>
        </div>
      </div>
    </div>
  );
}
